import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class SupplyAccountMultiSelectList implements IController {

  selectedIds: any;
  ngPlaceholder: any;
  disabledIds: any;
  supplierType: string;

  onChange: Function;

  private accountsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $accounts: $accountsFactory, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {
    this.accountsRef = this.$accounts();
    this.loadLimit = 20;

    this.accountsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.accountsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
  }

  onToggle(accountId, isSelected) {
    this.onChange({
      accountIds: isSelected ? _.concat(this.selectedIds || [], [accountId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== accountId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({accountIds: []});
    } else {
      this.onChange({accountIds: this.infiniteScroll?.getItems()?.map((account) => account.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(account => account.id), this.selectedIds);
    return this.isSelectAll;
  }

  private _reload() {
    this.accountsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      isSupply: true,
      type: this.supplierType,
      sort: 'name,asc'
    };
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountMultiSelectList', {
    bindings: {
      selectedIds: '<',
      ngPlaceholder: '@?',
      disabledIds: '<?',
      supplierType: '<?',
      onChange: '&'
    },
    template: require('./supply-account-multi-select-list.html').default,
    controller: SupplyAccountMultiSelectList
  });
